import { settingChangeSchema, settingViewSchema } from "@amtana/module";
import { z } from "zod";

// Cloudflare Turnstile's keys for the sign-up challenge (ADR-025 §8, revision 2), as staff see
// and change them in the back office (ADR-008): the site key (public, shown in full) and the
// secret (sealed, set or not with its last four), each defaulting to its environment variable
// (TURNSTILE_SITE_KEY, TURNSTILE_SECRET). Reuses the sign-in providers' settings store with
// "turnstile" as a third provider entry beside google and linkedin: no new table.

export const turnstileSettingsSchema = z.object({
  /** Both keys set, so the challenge can run once the `sign-up-challenge` flag is also on. */
  configured: z.boolean(),
  settings: z.object({
    siteKey: settingViewSchema,
    secret: settingViewSchema,
  }),
});
export type TurnstileSettings = z.infer<typeof turnstileSettingsSchema>;

/** Each field: a value to store, null to clear back to the environment, or left out. */
export const turnstileSettingsChangesSchema = z.object({
  siteKey: settingChangeSchema.optional(),
  secret: settingChangeSchema.optional(),
});
export type TurnstileSettingsChanges = z.infer<typeof turnstileSettingsChangesSchema>;

export const updateTurnstileSettingsInputSchema = z.object({ changes: turnstileSettingsChangesSchema });
export type UpdateTurnstileSettingsInput = z.infer<typeof updateTurnstileSettingsInputSchema>;
